// Patients other services imported straight into CatTrax. One waits for review: it can be booked, but tasks
// and clinical records can't be added until staff merge it into the patient it duplicates, or fill in its
// required details and confirm it as a new patient.
app.service("PatientImportAPI", [
	"$http",
	"ENV",
	"Session",
	function ($http, ENV, Session) {
		const service = {
			// A page of the practice's imported patients to review, and how many there are in all: those the import
			// couldn't create first (not_created says how many), then those waiting for review, each oldest first. A
			// filter of "NOT_CREATED" gets only the first. A size of 0 gets just the counts.
			getImportsToReview: function (page, size, filter) {
				return $http({
					method: "GET",
					url: ENV.API + "/api/patient-imports",
					params: { page: page || 0, size: size === undefined ? 25 : size, filter: filter || undefined },
					headers: {
						Authorization: "Bearer " + Session.token,
					},
				});
			},

			// How far the practice is through reviewing its imported patients: counts by status and source system, how
			// many were reviewed on each of the last 30 days, and by whom. Counts only, no patient details.
			getStats: function () {
				return $http({
					method: "GET",
					url: ENV.API + "/api/patient-imports/stats",
					headers: {
						Authorization: "Bearer " + Session.token,
					},
				});
			},

			// Where the patient came from, what it is missing, and the patients it may be merged into.
			getReview: function (patientId) {
				return $http({
					method: "GET",
					url: ENV.API + "/api/patients/" + patientId + "/import",
					headers: {
						Authorization: "Bearer " + Session.token,
					},
				});
			},

			confirm: function (patientId) {
				return $http({
					method: "POST",
					url: ENV.API + "/api/patients/" + patientId + "/import/confirm",
					headers: {
						Authorization: "Bearer " + Session.token,
					},
				});
			},

			// fields: the details to take from the imported patient, e.g. ["MOBILE_NUMBER", "ADDRESS"].
			merge: function (patientId, targetPatientId, fields) {
				return $http({
					method: "POST",
					url: ENV.API + "/api/patients/" + patientId + "/import/merge",
					headers: {
						Authorization: "Bearer " + Session.token,
						"Content-Type": "application/json",
					},
					data: {
						target_patient_id: targetPatientId,
						fields: fields || [],
					},
				});
			},

			// A patient the import couldn't create, for want of a usable name and date of birth: what the source record
			// held about them, why they weren't created, and a link to view each of their records (it lasts 10 minutes).
			getUncreated: function (uncreatedId) {
				return $http({
					method: "GET",
					url: ENV.API + "/api/patient-imports/uncreated/" + encodeURIComponent(uncreatedId),
					headers: {
						Authorization: "Bearer " + Session.token,
					},
				});
			},

			// One of the records of a patient the import couldn't create, as PDF bytes, by its place in the patient's
			// documents. Read through CatTrax, never from the bucket the import holds it in.
			getUncreatedDocument: function (uncreatedId, documentIndex) {
				return $http({
					method: "GET",
					url: ENV.API + "/api/patient-imports/uncreated/" + encodeURIComponent(uncreatedId) + "/documents/" + documentIndex,
					headers: {
						Authorization: "Bearer " + Session.token,
					},
					responseType: "arraybuffer",
				});
			},

			// Adds the records of a patient the import couldn't create to a patient: one already in CatTrax, or one just
			// registered for them (newPatient), who must then have every required detail. Resolves with that patient.
			// Sent again for the same patient, it finishes an attempt that stopped part-way.
			promoteUncreated: function (uncreatedId, patientId, newPatient) {
				return $http({
					method: "POST",
					url: ENV.API + "/api/patient-imports/uncreated/" + encodeURIComponent(uncreatedId) + "/promote",
					headers: {
						Authorization: "Bearer " + Session.token,
						"Content-Type": "application/json",
					},
					data: {
						patient_id: patientId,
						new_patient: !!newPatient,
					},
				});
			},

			// Which patient a merged-away patient went into. 404 when it was never merged.
			getMergedInto: function (patientId) {
				return $http({
					method: "GET",
					url: ENV.API + "/api/patients/" + patientId + "/merged",
					headers: {
						Authorization: "Bearer " + Session.token,
					},
				});
			},
		};

		return service;
	},
]);
